const locale = {
    placeholder: '시간 선택',
    rangePlaceholder: ['시작 시간', '종료 시간'],
};
export default locale;
